import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import misc from 'greenmotion-shared/vuex/misc';
import quotes from 'greenmotion-shared/vuex/quotes';
import editBooking from 'greenmotion-shared/vuex/edit-booking';
import search from 'greenmotion-shared/vuex/search';
import errors from 'greenmotion-shared/vuex/errors';
import { currencySyncPlugin } from 'greenmotion-shared/vuex/quotes/currencySync';

import { HTTP_CONFIG } from 'greenmotion-shared/common/http';

Vue.use(Vuex);
function getCurrency(state) {
    if (window.localStorage) {
        return localStorage.getItem('currency');
    }
    return state.quotes.quote.user_location_currency;
}

function getStateFromLandingPage() {
    let state = JSON.parse(window.localStorage.getItem('HTTP'));
    if (state && state.isLandingPage == true) {
        return state;
    }
    return false;
}

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    key: 'frontend-booking',
    reducer: (state) => {
        let reducedState = {
            bookingReference: null,
            userToken: state.userToken,
            guestToken: state.search.search.guestToken,
            search: {
                search: {
                    currency: getCurrency(state),
                    driverAge: state.search.search.driverAge,
                    guestToken: state.search.search.guestToken,
                },
            },
        };

        let landingPageState;
        if ((landingPageState = getStateFromLandingPage())) {
            reducedState.userToken = landingPageState.userToken;
            reducedState.guestToken = landingPageState.guestToken;
            reducedState.search.search.guestToken = landingPageState.guestToken;
            reducedState.search.search.currency = landingPageState.currency;
        }

        if (window.localStorage !== undefined) {
            HTTP_CONFIG(reducedState.search.search.currency, reducedState.guestToken, reducedState.userToken);
        }

        return reducedState;
    },
});

const debug = process.env.NODE_ENV !== 'production';

let config = Object.assign({ currency: null, guestToken: null, userToken: null }, JSON.parse(localStorage.getItem('HTTP')));

export default new Vuex.Store({
    modules: {
        quotes,
        editBooking,
        search,
        errors,
        misc,
    },
    state: {
        userToken: config.userToken,
    },
    mutations: {
        setUserToken(state, token) {
            state.userToken = token;
        },
    },
    actions: {
        refreshToken({ dispatch, state, commit }) {
            dispatch('fetchOrRefreshToken');
        },
    },
    strict: debug,
    plugins: [vuexLocal.plugin, currencySyncPlugin],
});
